var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pay-record"},[_vm._v(" 充值记录大萨达撒大多撒大奥所多 ")])}
var staticRenderFns = []

export { render, staticRenderFns }